import classNames from 'classnames'
import { Button, Icon, Typography } from 'src/modules/core/components'
import type { BookingAvailabilityErrorProps } from './booking-availability-error.interface'
import classes from './booking-availability-error.module.scss'

const DEFAULT_TITLE = 'We could not load the calendar'
const DEFAULT_MESSAGE =
  'Something went wrong while checking this provider’s availability. This is usually temporary, so please try again in a moment.'

export function BookingAvailabilityError({
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
  onRetry,
  isRetrying = false,
  className,
}: BookingAvailabilityErrorProps) {
  return (
    <div className={classNames(classes.root, className)} role="alert">
      <Icon name="warning" className={classes.icon} />
      <Typography variant="body" className={classes.title}>
        {title}
      </Typography>
      <Typography variant="body" className={classes.message}>
        {message}
      </Typography>
      {onRetry && (
        <Button
          variant="secondary"
          widthType="content"
          onClick={onRetry}
          isLoading={isRetrying}
          loadingLabel="Trying again..."
          className={classes.retryButton}
        >
          Try again
        </Button>
      )}
    </div>
  )
}
